<template>
    <div>
        <div v-if="!flat" class="skeleton-line"></div>
        <div class="flex justify-between q-pt-sm">
            <div class="skeleton-line" style="width: 50px"></div>
            <div class="skeleton-line" style="width: 100px"></div>
        </div>
        <div class="flex justify-between q-pt-sm no-wrap">
            <div class="skeleton-square" style="height: 60px; min-width: 80px"></div>
            <div class="skeleton-line percent50" style="height: 60px; min-width: 120px"></div>
        </div>
    </div>
</template>
<script setup lang="ts">
defineProps<{ flat: boolean }>();
</script>
